
import { Outlet } from "react-router-dom";

export default function ClientLayout() {
  return (
    <>
      
      <div>
        <Outlet />
      </div>
    </>
  );
}
